import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import WordAnalyzer from './components/WordAnalyzer';
import Home from './components/Home';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              Sharva Labs
            </Link>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/word-analyzer" className="nav-link">Word Analyzer</Link>
              </li>
            </ul>
          </div>
        </nav>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/word-analyzer" element={<WordAnalyzer />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>&copy; 2024 Sharva Labs. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;

